import { Pipe, PipeTransform } from '@angular/core';
import { cleanObject } from '@x/common/utils';
import { IShopAddress, IShopAddressInput } from '@x/ecommerce/shop-client';
import { Maybe } from '@x/schemas/ecommerce';

@Pipe({
  name: 'shopAddress',
})
export class AddressPipe implements PipeTransform {
  transform(
    address: Maybe<IShopAddress | IShopAddressInput> | null | undefined,
    separator: string = ', ',
  ): any {
    if (!address || typeof address !== 'object') return;

    const addressToDisplay: Partial<IShopAddress> = {
      street: address.street,
      suburb: address.suburb,
      city: address.city,
      complex: address.complex,
      postalCode: address.postalCode,
      province: address.province,
      country: address.country,
    };

    return Object.values(cleanObject(addressToDisplay)).join(separator);
  }
}
